<div
  class="flex flex-col gap-6 md:gap-16 lg:gap-20 md:items-center xl:gap-32 px-8 md:px-16 lg:px-24 xl:px-32 py-8 md:py-20"
  [ngClass]="{
    'flex-col-reverse md:flex-row-reverse': imageTileData.imagesRight,
    'flex-col md:flex-row': !imageTileData.imagesRight,
    'bg-white text-ss-brown': !imageTileData.darkBackground,
  }"
>
  <div
    class="basis-4/6 grid gap-4 aspect-[4/5] grid-cols-9 auto-rows-fr"
    [ssDirectus]="{
      collection: 'imageTiles',
      item: imageTileData.id,
      fields: ['images', 'variant'],
    }"
  >
    @if (imageTileData.images && imageTileData.variant) {
      @for (
        item of imageTileData.images;
        track imageTrackByFn(i, item);
        let i = $index
      ) {
        @if (
          item.directus_files_id.id &&
          i < layouts[+imageTileData.variant].length
        ) {
          <ss-www-image-with-loader
            class="rounded-xl"
            [ngClass]="layouts[+imageTileData.variant][i]"
            [fileDetail]="item.directus_files_id"
            desktopImageSize="half"
          ></ss-www-image-with-loader>
        }
      }
    }
  </div>
  <div class="basis-2/6 grow">
    <div
      [innerHTML]="imageTileData.text"
      [ssDirectus]="{
        collection: 'imageTiles',
        item: imageTileData.id,
        fields: ['text'],
      }"
    ></div>
    @if (imageTileData.card?.[0]?.item?.text) {
      <ss-www-info-card
        class="block mt-6"
        [ssDirectus]="{
          collection: 'imageTiles',
          item: imageTileData.id,
          fields: ['card'],
        }"
        [infoCardText]="imageTileData.card![0]!.item.text!"
        [darkBackground]="imageTileData.darkBackground ?? true"
      ></ss-www-info-card>
    }
    <div
      class="flex row mt-8"
      [ssDirectus]="{
        collection: 'imageTiles',
        item: imageTileData.id,
        fields: ['buttons'],
      }"
    >
      @for (
        button of imageTileData.buttons;
        track buttonTrackByFn($index, button)
      ) {
        <ss-building-block-button-link [buttonLink]="button.item">
        </ss-building-block-button-link>
      }
    </div>
  </div>
</div>
